import './password-rules.scss';

import { useTranslation } from 'react-i18next';

import { CheckCircle } from '@/media/icons';
import {
  PASSWORD_MAX,
  PASSWORD_MIN,
  PASSWORD_RULE_MESSAGE_KEYS,
  getPasswordRules
} from '@/shared/services/password';

interface IProps {
  /** Текущее значение нового пароля. */
  value: string;
}

/** Подсказка под полем нового пароля: требования и отметка о выполненных. */
const PasswordRules: React.FC<IProps> = ({ value }) => {
  const { t } = useTranslation();

  return (
    <ul className="password-rules">
      {getPasswordRules(value).map(({ rule, passed }) => (
        <li
          key={rule}
          className={`password-rules__item${passed ? ' password-rules__item--passed' : ''}`}
        >
          {passed ? (
            <CheckCircle className="password-rules__icon" aria-hidden />
          ) : (
            <span className="password-rules__mark" aria-hidden />
          )}
          {t(PASSWORD_RULE_MESSAGE_KEYS[rule], {
            min: PASSWORD_MIN,
            max: PASSWORD_MAX
          })}
        </li>
      ))}
    </ul>
  );
};

export default PasswordRules;
